import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '../../design-system/button/Button';

import styles from './WelcomeToPlacementTest.module.scss';

const WelcomeToPlacementTest = ({ placementTestInfo, handleStart, student }) => {
  // Auto-start the placement test when component mounts
  useEffect(() => {
    handleStart();
  }, [handleStart]);

  return (
    <div className={styles['welcome-wrapper']}>
      <h1 className={styles['welcome-title']}>Discover your {placementTestInfo?.language} level</h1>
      <p className={styles['welcome-subtitle']}>
        {student?.first_name}, let&apos;s make sure your {placementTestInfo?.language} lessons start at the perfect level for you. This takes less
        than 5 minutes and it&apos;s just a way to find your best starting point.
      </p>
      <Button onClick={handleStart} outfit="greenButton" id="start-placement-test">
        Let&apos;s find out
      </Button>
      <p className={styles['welcome-hint']}>Shouldn&apos;t take more than 5 minutes</p>
    </div>
  );
};

const mapStateToProps = (state) => ({
  placementTestInfo: state.user.placement_test_info,
  student: state.user
});

WelcomeToPlacementTest.propTypes = {
  placementTestInfo: PropTypes.object.isRequired,
  handleStart: PropTypes.func.isRequired,
  student: PropTypes.object.isRequired
};

export default connect(mapStateToProps)(WelcomeToPlacementTest);
